import script from "./PublicBadges.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublicBadges.vue?vue&type=script&setup=true&lang=ts"

import "./PublicBadges.vue?vue&type=style&index=0&id=d20a9c70&scoped=true&lang=css"
import "./PublicBadges.vue?vue&type=style&index=1&id=d20a9c70&lang=css"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d20a9c70"]])

export default __exports__